export default __webpack_public_path__ + "static/media/invoice_top_right_red_bg.1255a061.svg";